import React, {useState,useEffect,useMemo} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ArrowRightIcon from '@mui/icons-material/ArrowRightAlt';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import VisitConfirm from './VisitConfirm';
import BottomButtons from './BottomButtons';
import {Tools} from './Tools';
import {Owner,Visit,Dataset} from './Inc';
import Ajax from './Ajax';
import Toast from './Toast';
//import Success from './Success';
import Title from './Title';
import Loading from './Loading';

interface VisitInputProps {
	
}

const VisitClose = (props:VisitInputProps)=> {
	const classes = useStyles();

	return (
		<div className={classes.root+" "+classes.policy}>
				<Paper className={classes.paper}>
					<Title text="井の頭倉庫（休止）" size={1} icon="cart"/>
					<div style={{marginBottom:"2em"}}>
						<p>ごめんなさい<br/>井の頭倉庫の対応は現在休止中です</p>
					</div>
				</Paper>
		</div>
	);
}

export default VisitClose;
